import { MainLabel, SecondaryLabel } from '~/components/table/TableLabels';
import { useEllipsisTooltip } from '~/hooks/useEllipsisTooltip';
import HighlightText, { HighlightTextProps } from '../HighlightText';
import SimpleTooltip from '../data-display/SimpleTooltip';

interface Props {
  label: string | undefined;
  textToHighlight?: HighlightTextProps['textToHighlight'];
  variant?: 'main' | 'secondary' | 'error';
  className?: string;
  tooltipClassName?: string;
}

const MaybeHightlightedLabel: React.FC<{ label: string; textToHighlight?: HighlightTextProps['textToHighlight'] }> = ({
  label,
  textToHighlight,
}) => {
  if (!textToHighlight) {
    return <>{label}</>;
  }

  return <HighlightText text={label} textToHighlight={textToHighlight} />;
};

const LabelWithTooltip: React.FC<Props> = ({
  label: labelStr,
  textToHighlight,
  variant = 'main',
  className,
  tooltipClassName,
}) => {
  const { ref, title } = useEllipsisTooltip(labelStr);
  const label = <MaybeHightlightedLabel label={labelStr || ''} textToHighlight={textToHighlight} />;
  const enableTooltip = title ? title.length > 0 : false;

  if (variant === 'secondary') {
    return (
      <SimpleTooltip mode="div" title={title} allowTooltip={enableTooltip} tooltipClassName={tooltipClassName}>
        <div ref={ref} className={className}>
          <SecondaryLabel className={className}>{label}</SecondaryLabel>
        </div>
      </SimpleTooltip>
    );
  }

  return (
    <SimpleTooltip title={title} mode="div" allowTooltip={enableTooltip} tooltipClassName={tooltipClassName}>
      <div ref={ref} className={className}>
        <MainLabel error={variant === 'error'} className={className}>
          {label}
        </MainLabel>
      </div>
    </SimpleTooltip>
  );
};

export default LabelWithTooltip;
